<template lang="pug">
  b-modal#updateBLLC(
    ref="updateBLLC"
    :title="$t('ui.combine.update_bet_limit')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="md"
    @ok="done"
    @show="reset"
    @shown="shown"
    :hide-footer="!$helpers.getVisible(editLimit)"
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      span #[b {{ $t("ui.account_id") + " : " + accountId.toUpperCase() }}]
      #tblModal.table-sm.table-responsive
        table.table.table-bordered
          thead
            tr
              th &nbsp;
              th {{ $t("ui.bet_limit_packages") }}
          tbody(v-if="$store.getters.getBetLimit")
            tr
              th 
                span {{ $t("ui.live_casino") }}
                br 
                span.small.text-danger(v-html='$t("ui.livecasino_tooltips")')
              td#betLimit.w-50
                b-form-checkbox-group(
                  v-if="!$helpers.isAgentLevel()"
                  ref="livecasino_bet_limit_packages"
                  :class="{ 'is-invalid': $v.livecasino_bet_limit_packages.$dirty == true && $v.livecasino_bet_limit_packages.$error == true, 'is-valid': $v.livecasino_bet_limit_packages.$dirty == true && $v.livecasino_bet_limit_packages.$error == false }"
                  v-model.trim.lazy="livecasino_bet_limit_packages"
                  :options="livecasino_bet_limit_packages_options"
                  stacked
                  :state="stateBLLC"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
                b-form-select(
                  v-if="$helpers.isAgentLevel()"
                  ref="livecasino_bet_limit_packages"
                  :class="{ 'is-invalid': $v.livecasino_bet_limit_packages.$dirty == true && $v.livecasino_bet_limit_packages.$error == true, 'is-valid': $v.livecasino_bet_limit_packages.$dirty == true && $v.livecasino_bet_limit_packages.$error == false }"
                  v-model.trim.lazy="livecasino_bet_limit_packages"
                  :options="livecasino_bet_limit_packages_options"
                  size="sm"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import CommInput from "@/library/CommInput";

export default {
  components: {
    CommInput,
    SubmitButton
  },
  props: {
    accountId: ""
  },
  data() {
    return {
      loading: false,
      livecasino_bet_limit_packages: [],
      submission: {
        success: true,
        status: ""
      }
    }
  },
  validations: {
    livecasino_bet_limit_packages: {
      required(value){
        return !this.$helpers.isAgentLevel() ? value.length >= 1 && Object.values(value).includes("A") ? true : false : true
      }
    }
  },
  computed: {
    currencyCode: function() {
      return this.$store.getters.getAccountCurrency
    },
    editLimit() {
      return [config.accessRoles.editLimit]
    },
    livecasino_bet_limit_packages_options: function() {
      let packages = this.$store.getters.getBetLimitPackage[0].bet_limit_package
      let result = []
      if(packages) {
        packages = packages.replace(/ +/g, "").split(",")
        packages.sort().forEach((value, index) => {
          result.push({ value:value, text:this.$t("ui.combine.bet_limit_" + this.currencyCode + value), disabled: ((this.$helpers.isAgentLevel()) ? false : index == 0) })
        })
      }
      return result
    },
    stateBLLC(){
      return !this.$helpers.isAgentLevel() ? this.livecasino_bet_limit_packages.length >= 1 && Object.values(this.livecasino_bet_limit_packages).includes("A") : true
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault()
      this.submit()
    },
    getChildBetLimit: function() {
      let account_id = this.accountId
      let platform_code = "LIVECASINO"
      if(account_id) {
        this.$store
        .dispatch("user/getChildBetLimit", { account_id, platform_code })
        .then(response => {
          if(this.$helpers.isAgentLevel()) {
            let isExist = true
            for(let x in this.livecasino_bet_limit_packages_options) {
              let y = response.data.bl[0].bet_limit_package
              let z = this.livecasino_bet_limit_packages_options[x].value
              if(y == z) {
                isExist = true
                break
              }
            }
            if(isExist){
              this.$v.livecasino_bet_limit_packages.$model = response.data.bl[0].bet_limit_package
            } else {
              this.$v.livecasino_bet_limit_packages.$model = 'A'
            }
          } else {
            this.$v.livecasino_bet_limit_packages.$model = response.data.bl[0].bet_limit_package.split(",")
          }
        })
        .catch(response => {
          // console.log("child", response)
        });
      } else {
        this.cancel()
      }
    },
    submit: function() {
      // this.reset()
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_account_bet_limit_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.updateBetLimitLC()
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_account_bet_limit_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    updateBetLimitLC: function() {
      let account_id = this.accountId
      let bet_limit_packages = this.livecasino_bet_limit_packages
      this.$store
        .dispatch("user/updateBetLimitLC", { account_id, bet_limit_packages })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.update_account_bet_limit_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          // console.log("Failed:updateBetLimitLC", response)
          this.loading = false;
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
      this.livecasino_bet_limit_packages = []
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset()
        this.$helpers.getBetLimit()
        this.getChildBetLimit()
      });
    },
    cancel: function() {
      // this.$emit("clicked")
      this.$refs.updateBLLC.hide()
    }
  }
};
</script>

